import React from 'react';
import { useRequest } from 'ahooks';
import { api } from "@redux/api";
import PeiChart from "@containers/facility/Overview/PieChart";
import { useAuth } from '@/hooks/use-auth';
import { Nopermission } from '@/components/Nopermission';
import { useNavigate } from 'react-router-dom';
import { emitEvent } from '@/hooks/useEventBus';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '@redux/app/actions';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';


const WorkorderByPriorityChart = () => {
    const workorderPermission = useAuth('workorder', 1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const facilityId = useSelector(state => state?.Facility?.selected?.Id);
    const facilityContext = useSelector((state) => getFacilityContext(state));

    const { data: workorderData } = useRequest(
        () => api.allworkorderview(),
        {
            ready: workorderPermission,
            cacheKey: `workorder-priority-chart-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    if (!workorderPermission) {
        return <Nopermission />;
    }

    const groupedPriorityData = workorderData?.data?.grouped_priority_data;

    if (!groupedPriorityData) {
        return null;
    }

    const handleWorkOrderPriorityClick = (e) => {
        emitEvent('CLOSE_WORKORDER');
        const url = buildFacilityPath('workorder', {
            ...facilityContext,
            query: { priority: e.data.name },
        }) || '/switch-view';
        navigate(url);
        dispatch(appActions.changeCurrent(['workorder']));
    };

    return (
        <PeiChart
            data={groupedPriorityData}
            height={200}
            colors={{
                'Urgent': '#ef4444',
                'Important': '#fb923c',
                'Low': '#4ade80'
            }}
            title={'Workorder by Priority'}
            handleChartClick={handleWorkOrderPriorityClick}
        />
    );
};

export default WorkorderByPriorityChart; 
